/**
 * Grid Component
 */

import React, { FC, Children } from 'react';
import { withTheme } from 'styled-components';
import GridItem from './GridItem/grid-item';
import { GridWrapper } from './grid.style';
import { GridAlignTypes, GridProps } from './grid.types';


const Grid: FC<GridProps> = ({
  children,
  verticalGutter = 0,
  horizontalGutter = 0,
  hasBorderGutter = true,
  theme = {},
  justifyContent = GridAlignTypes.FLEX_START,
  data,
  dataAttr,
  ...props }) => {

  // Retrieve the breakpoints from the theme
  const { breakpoints } = theme;

  // Add necessary props to any exisitng Grid Item children
  const childrenWithBreakpoints = Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      const type = child.type as any;
      const displayName = type.name as string;
      if (displayName === 'GridItem') {
        return React.cloneElement(child, {
          breakpoints,
          verticalGutter,
          horizontalGutter
        });
      } else {
        return React.cloneElement(child);
      }
    } else {
      return child;
    }
  });

  // Display GridItem Array prop as well as any children the grid has
  return (
    <GridWrapper
      verticalGutter={verticalGutter}
      horizontalGutter={horizontalGutter}
      hasBorderGutter={hasBorderGutter}
      justifyContent={ justifyContent }
      {...props} >

      { data && data.length > 0 && data.map((propObj, index) =>
        <GridItem
          breakpoints={breakpoints}
          verticalGutter={verticalGutter}
          horizontalGutter={horizontalGutter}
          {...propObj}
          key={`grid-data${index}`}
          dataAttr={dataAttr}
          />
      )}

      { childrenWithBreakpoints }

    </GridWrapper>
  );
};

export default withTheme(Grid);
